// extracted by mini-css-extract-plugin
export var dateLabel = "_2e-0";
export var dateLabelError = "_2e-1";
export var fullWidth = "_2e-2";
export var smaller = "_2e-3";